import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/5599338006c54fe6ce07ff64cfd8f48c/4f72f15ed9b284405d9fe611c977c9b0.png"
              alt="Security Services Logo"
              className="h-12 w-auto"
            />
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/') ? 'text-[#1a2b4a]' : 'text-gray-600 hover:text-[#1a2b4a]'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/services') ? 'text-[#1a2b4a]' : 'text-gray-600 hover:text-[#1a2b4a]'
              }`}
            >
              Services
            </Link>
            <Link
              to="/tour"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/tour') ? 'text-[#1a2b4a]' : 'text-gray-600 hover:text-[#1a2b4a]'
              }`}
            >
              Solutions Tour
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/contact') ? 'text-[#1a2b4a]' : 'text-gray-600 hover:text-[#1a2b4a]'
              }`}
            >
              Contact
            </Link>
          </div>

          {/* CTA Button */}
          <Link
            to="/contact#consultation"
            className="hidden md:block bg-[#1a2b4a] text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-[#2a3b5a] transition-colors whitespace-nowrap cursor-pointer"
          >
            Schedule Consultation
          </Link>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-600 hover:text-[#1a2b4a] cursor-pointer"
            onClick={() => {
              const menu = document.getElementById('mobile-menu');
              menu?.classList.toggle('hidden');
            }}
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div id="mobile-menu" className="hidden md:hidden pb-4">
          <div className="flex flex-col space-y-3">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/') ? 'text-[#1a2b4a]' : 'text-gray-600'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/services') ? 'text-[#1a2b4a]' : 'text-gray-600'
              }`}
            >
              Services
            </Link>
            <Link
              to="/tour"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/tour') ? 'text-[#1a2b4a]' : 'text-gray-600'
              }`}
            >
              Solutions Tour
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/contact') ? 'text-[#1a2b4a]' : 'text-gray-600'
              }`}
            >
              Contact
            </Link>
            <Link
              to="/contact#consultation"
              className="bg-[#1a2b4a] text-white px-6 py-2.5 rounded-lg text-sm font-medium text-center whitespace-nowrap cursor-pointer"
            >
              Schedule Consultation
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
